import cloneDeep from 'lodash/cloneDeep';

import Base from 'app/models/base';
import TrackingDetails from 'app/collections/tracking_details';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('trackers'),
  rootKey: 'tracker',

  parse(attributes) {
    const attrs = { rawJSON: cloneDeep(attributes), ...attributes };

    if (attrs.tracking_details) {
      attrs.tracking_details = new TrackingDetails(attrs.tracking_details);
    }
    return attrs;
  },
});



// WEBPACK FOOTER //
// ./app/models/tracker.js